import { Component, Vue} from "vue-property-decorator";
import { TranslationModel } from "../../../models/product";
import http from "@/services/Http";
import { CheckoutCost, FreightCostCheckoutResponse } from "@/models/checkoutFreight";
import { EventBus } from "@/events";
import { appStore } from "@/store/AppModule";

@Component
export default class CheckoutSummary extends Vue {
    protected vm: any = {};
    protected total: string = "";
    protected orderRowTotal: string = "";
    protected palletSplitFee: string = "";
    protected hasPalletSharingFee: boolean = false;
    protected zipCode: string = "";
    protected translations: TranslationModel;
    protected jeevesResult: CheckoutCost = {} as CheckoutCost;
    protected currencyCode: string = "";
    protected palletCost: string = "";
    protected freightCost: string = "";
    protected freightServiceCost: string = "";

    private url: string = window.location.origin + window.location.pathname;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.total = this.$attrs.total;
        this.orderRowTotal = this.$attrs.orderrowtotal;
        this.palletSplitFee = this.$attrs.palletsplitfee;
        this.hasPalletSharingFee = this.$attrs.haspalletsharingfee === "true";
        this.zipCode = this.$attrs.zipcode;
        this.currencyCode = this.$attrs.currencycode;
    }

    protected mounted() {
        this.getCheckoutFreightCost();

        EventBus.$on("refreshCartSummary", (variantId: string) => {
            this.getCheckoutFreightCost();
        });
    }

    protected getCheckoutFreightCost() {
        http.get<FreightCostCheckoutResponse>(`${this.url}.GetCheckoutFreightCost?zip=` + this.zipCode)
        .then(r => {
            const responseData = r as FreightCostCheckoutResponse;
            this.jeevesResult = responseData.freightCostCheckout;
            this.palletSplitFee = responseData.palletSplitFee;
            this.orderRowTotal = responseData.orderRowTotal;
            this.total = responseData.orderTotal;
            this.palletCost = this.jeevesResult.PalletCost > 0 ? this.formatNumber(this.jeevesResult.PalletCost) : "";
            this.freightCost = this.jeevesResult.FreightCost > 0 ? this.formatNumber(this.jeevesResult.FreightCost) : "";
            this.freightServiceCost = this.jeevesResult.FreightServiceCost > 0 ? this.formatNumber(this.jeevesResult.FreightServiceCost) : "";
            const totalElem = document.getElementById("reseller-checkout-total");
            if (totalElem) {
                totalElem.innerText = responseData.orderTotal;
            }
            console.log(this.jeevesResult);
        });
    }

    protected formatNumber(value: number) {
        return value.toLocaleString(appStore.state.culture, {maximumFractionDigits: 2, minimumFractionDigits: 2});
    }
}
